/**
 * Extended FAQ – exclusive accordion (+ / ×)
 */
(function () {
  'use strict';

  function initAccordion(root) {
    const items = root.querySelectorAll('[data-efaq-item]');
    if (!items.length) return;

    items.forEach((item) => {
      const trigger = item.querySelector('[data-efaq-trigger]');
      const panel = item.querySelector('[data-efaq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((other) => {
          const otherTrigger = other.querySelector('[data-efaq-trigger]');
          const otherPanel = other.querySelector('[data-efaq-panel]');
          other.classList.remove('is-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function initSection(sectionRoot) {
    const accordion = sectionRoot.querySelector('[data-efaq-accordion]');
    if (accordion && accordion.dataset.efaqReady !== 'true') {
      accordion.dataset.efaqReady = 'true';
      initAccordion(accordion);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-extended-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-extended-faq]');
    if (root) initSection(root);
  });
})();
